module.exports = __webpack_public_path__ + "static/media/plain-ball-2.66f4e690.gif";